<template>
    <div class="shoulder-container">
        <div class="d-inline-block" :class="label ? 'text-center' : ''" v-for="(image, imageIndex) in images" :key="imageIndex">
            <span v-b-tooltip :title="tooltip ? imageName[imageIndex] : null" role="button" @click="clicked(imageIndex)" class="pointer shoulder-item" :class="selected === imageIndex ? 'shoulder-item-selected' : ''">
                <component :selected="selected === imageIndex" :is="image" :width="adjustSize(width, imageIndex)" :height="adjustSize(height, imageIndex)"></component>
            </span>
            <label v-if="label" class="m-0 mt-1">
                {{imageName[imageIndex]}}
            </label>
        </div>
    </div>
</template>

<script>
    import Image1 from '@/components/Lab/Shoulder/1';
    import Image2 from '@/components/Lab/Shoulder/2';
    import Image3 from '@/components/Lab/Shoulder/3';
    import {labMixin} from "@/mixins/lab";

    export default {
        name: "Shoulder",
        props: ['label', 'tooltip'],
        mixins: [labMixin],
        components: {
            Image1, Image2, Image3
        },
        data() {
            return {
                numImages: 3,
                imageName: [this.$t('Vestib'), '360°', this.$t('Without')]
            }
        },
        watch: {},
        computed: {},
        methods: {}
    }
</script>

<style lang="scss">

    .shoulder-container {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 10px 0;
    }

    .shoulder-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        width: 50px;
        //border: 1px solid #e3ebf6;
        &-selected {
            border: 2px solid #99d1ff;
            background: #cce8ff;
        }
        &:hover {
            background: #e5f3ff;
        }
    }

    .shoulder-stroke {
        stroke: #c1c1c1;
        stroke-width: 4;
        stroke-miterlimit: 10;
    }

    .fill-black {
        fill: #0d1b2b;
    }

    .shoulder-fill {
        fill: #ffffff;
        stroke: #ccc;
        stroke-width: 2;
    }

    .shoulder-fill:hover {
        stroke: #f6c343;
        stroke-width: 2;
        /* zoom: 10; */
    }

    .shoulder-active {
        //stroke: red;
        stroke-dasharray: 0;
    }
</style>
